import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const CAAutoFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="CA Auto"
      slug="/lenders/mis-sold-ca-auto-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default CAAutoFinancePage
